import React from "react";
import { Navigate, useLocation } from "react-router";
import PropTypes from "prop-types";
import useAuth from "../hooks/useAuth";
import { usePermissions } from "src/contexts/permissions";
import { buildLoginRedirectUrl } from "../utils/authReturnTo";

const ShoppingGuard = ({ children }) => {
  const { isAuthenticated } = useAuth();
  const { can } = usePermissions();
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to={buildLoginRedirectUrl(location)} replace />;
  }

  if (!can("pages.shopping") && !can("pages.shopping_cart")) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

ShoppingGuard.propTypes = {
  children: PropTypes.node,
};

export default ShoppingGuard;
